import { render } from "./dzjyDetail.vue?vue&type=template&id=e1d32aea&scoped=true&ts=true"
import script from "./dzjyDetail.vue?vue&type=script&lang=ts"
export * from "./dzjyDetail.vue?vue&type=script&lang=ts"

import "./dzjyDetail.vue?vue&type=style&index=0&id=e1d32aea&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1d32aea"]])

export default __exports__